import { render, staticRenderFns } from "./cHeader.vue?vue&type=template&id=187b2c3a&scoped=true&"
import script from "./cHeader.vue?vue&type=script&lang=js&"
export * from "./cHeader.vue?vue&type=script&lang=js&"
import style0 from "./cHeader.vue?vue&type=style&index=0&id=187b2c3a&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187b2c3a",
  null
  
)

export default component.exports